import { useEffect, useState } from 'react';
import { Select, Input, Button, Icon } from '@tencent/met-ui';
import { countryData } from '@constant/country';
import { useTranslation } from 'react-i18next';
import './MobileVerify.scss';
import { openToast } from '@component/toast';
import { checkMobile, sendSmsCode, SendSmsReq } from '@services/cgi';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { checklawful } from '@store/authentication/authentication.trunk';
import { changeIfShowMobileVerify } from '@store/ui/ui.slice';
import { useNavigate } from 'react-router-dom';
import { getMeetingInfoInput } from '@store/meeting/meeting.slice';
import { filterDigit } from '@utils/string';

let timer: any;
const SEPARATOR = '^_^';
const countryCodeOptions = countryData.map((item) => ({
  text: (
    <div key={`${item.country}${item.name}+${item.areaCode}${item.code_name || ''}`} className="code-option-item">
      <span title={item.country}>{item.country}</span>
      <span>+{item.areaCode}</span>
    </div>
  ),
  value: `${item.areaCode}${SEPARATOR}${item.code_name}`,
}));

export default function MobileVerify() {
  const dispathch = useAppDispatch();
  const { t } = useTranslation();
  const meetingInfoInput = useAppSelector(getMeetingInfoInput);
  const navigate = useNavigate();

  const [sendSmsLoading, setSendSmsLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [mobile, setMobile] = useState('');
  const [areaCode, setAreaCode] = useState('852');
  const [areaCodeName, setAreaCodeName] = useState('CN');
  const [code, setCode] = useState('');
  const [startInterval, setStartInterval] = useState(false);
  const [countText, setCountText] = useState(t('{#num#} 秒后可重新发送', { num: 60 }));

  useEffect(() => {
    timer && clearInterval(timer);
    return () => timer && clearInterval(timer);
  }, []);

  const changeAreaCode = (areaCode: string) => {
    const array = areaCode?.split(SEPARATOR);
    setAreaCode(array?.[0]);
    setAreaCodeName(array?.[1]);
  };

  const onMobileChange = (value: string) => {
    setMobile(value);
  };

  const onCodeChange = (value: string) => {
    setCode(value);
  };

  const afterCountDownFinish = () => {
    setStartInterval(false);
    clearInterval(timer);
  };

  const countDown = () => {
    let times = 60;
    setStartInterval(true);
    timer = setInterval(() => {
      times = times - 1;
      setCountText(t('{#num#} 秒后可重新发送', { num: times }));
      if (times <= 0) {
        afterCountDownFinish();
      }
    }, 1000);
    // setInterval(() => {
    //   times = times - 1;
    //   setCountText(t('{#num#} 秒后可重新发送', { num: times }));
    //   if (times <= 0) {
    //     afterCountDownFinish();
    //   }
    // }, 1000);
  };

  const sendCode = () => {
    if (mobile.length === 0) {
      openToast(t('请输入正确的手机号码'));
      return;
    }

    sendSmsCodeRequest({
      area: areaCode,
      phone: mobile,
      // TODO 弄一个常量
      /** @description 游客入会 常量传8  */
      business_id: '8',
    });
  };

  const sendSmsCodeRequest = (params: SendSmsReq) => {
    setSendSmsLoading(true);
    sendSmsCode(params)
      .then((res) => {
        if (res.code === 0) {
          // 已发送
          // TODO 倒计时
          countDown();
        } else if (res.code === -40000) {
          // 请输入正确的手机号码
          openToast(t('请输入正确手机号码'));
        } else if (res.code === -51009) {
          const captcha1 = new window.TencentCaptcha(
            '188904464',
            (res: { randstr: string; ticket: string }) => {
              console.log('防水墙callback, res:', res);
              if (res.randstr === '' && res.ticket === '') {
                return;
              }
              sendSmsCodeRequest({
                business_id: '8',
                area: areaCode,
                phone: mobile,
                ticket: res.ticket,
                rand_string: res.randstr,
              });
            },
            {
              userLanguage: 'en',
            },
          );
          captcha1.show();
        } else if (res.code === -40003) {
          // 短信验证码发送次数超出次数限制;
          openToast(t(res.message || t('短信发送太频繁，请稍后再试')));
        } else {
          openToast(res.message);
        }
      })
      .finally(() => {
        setSendSmsLoading(false);
      });
  };

  const onBack = () => {
    dispathch(changeIfShowMobileVerify(false));
  };

  const onVerifyMobile = () => {
    if (mobile.length === 0) {
      openToast(t('请输入正确的手机号码'));
      return;
    }

    if (code.length === 0) {
      openToast(t('请输入正确的手机号码'));
      return;
    }

    setVerifyLoading(true);

    checkMobile({
      area: areaCode,
      business_id: '8',
      phone: mobile,
      code,
    })
      .then(async (res) => {
        if (res.code === 0) {
          // 验证成功
          const lawfulResult = await dispathch(checklawful(res.data.auth_code));
          if (!lawfulResult.payload) {
            // 不要合规
            setVerifyLoading(false);
            navigate(`/${filterDigit(meetingInfoInput.meetingCode)}/${window.location.search}`);
          }
        } else if (res.code === -40002) {
          openToast(t(res.message || t('验证码错误，请重新输入')));
        } else {
          openToast(res.message);
        }
      })
      .finally(() => {
        setVerifyLoading(false);
      });
  };
  return (
    <div className="mobile-verify">
      <div className="mobile-verify__header">
        <Icon
          type="arrowleft--line"
          className="mobile-verify__header__back"
          onClick={onBack}
          color="#4E5461"
          size={20}
        />
      </div>
      <div className="mobile-verify__header-title">{t('验证手机号')}</div>
      <div className="mobile-verify__title">{t('手机号')}</div>
      <div className="mobile-verify__input-item">
        <Select
          placeholder={areaCode}
          className="mobile-verify__phone-select"
          type="simulate"
          appearance="button"
          searchable={true}
          boxSizeSync
          listHeight={300}
          options={countryCodeOptions}
          value={`${areaCode}${SEPARATOR}${areaCodeName}`}
          onChange={changeAreaCode}
          boxClassName="mobile-verify__country-code-select-box"
          button={`+${areaCode}`}
          filter={(inputValue, option) => {
            const keyword = inputValue?.toLowerCase().trim();
            // @ts-ignore
            const name = option.text?.key?.toLowerCase();
            return name?.includes(keyword);
          }}
        />
        <Input
          className="mobile-verify-input-item-mobile"
          value={mobile}
          onChange={onMobileChange}
          placeholder={t('输入手机号')}
        />
      </div>
      <div className="mobile-verify__title">{t('验证码')}</div>
      <div className="mobile-verify__input-item">
        <Input
          className="mobile-verify__input-item__code"
          value={code}
          onChange={onCodeChange}
          placeholder={t('输入验证码')}
        />
        <Button
          className="mobile-verify__input-item__send"
          onClick={sendCode}
          disabled={startInterval}
          loading={sendSmsLoading}
        >
          {startInterval ? countText : t('发送验证码')}
        </Button>
      </div>

      <Button
        type="primary"
        loading={verifyLoading}
        className="mobile-verify__button"
        onClick={onVerifyMobile}
        disabled={code.length === 0 || mobile.length === 0}
      >
        {t('下一步')}
      </Button>
    </div>
  );
}
